export default function roomCBTEventListener(room) {
  return store => {
    room.addEventListeners({
      /**
       * CBT 초기화
       */
      room_cbt_ready: (e) => {
        store.commit('cbt/SET_ROOM_CBT', e.data);
      },

      /**
       * CBT 시작
       */
      room_cbt_start: (e) => {
        store.commit('cbt/CLEAN_ROOM_CBT_USER_LIST');
        store.commit('cbt/SET_ROOM_CBT', e.data);
      },

      /**
       * CBT 종료
       */
      room_cbt_end: (e) => {
        store.commit('cbt/CLEAN_ROOM_CBT');
      },

      /**
       * CBT 답안 제출
       */
      room_cbt_user_complete: (e) => {
        store.commit('cbt/COMPLETE_ROOM_CBT_USER', e.data);
      },

      /**
       * CBT 사용자 등록
       */
      room_cbt_user_create: (e) => {
        store.commit('cbt/SET_ROOM_CBT_USER', [e.data.roomCbtUser]);
      },

      /**
       * CBT 사용자 초기화
       */
      room_cbt_user_set: (e) => {
        store.commit('cbt/SET_ROOM_CBT_USER', e.data);
      },

      /**
       * CBT 답안 업데이트
       */
      room_cbt_user_submit: (e) => {
        store.commit('cbt/UPDATE_ROOM_CBT_USER_ANSWER', e.data);
      },

      /**
       * CBT 답안 설정
       */
      room_cbt_user_answer_list_set: (e) => {
        store.commit('cbt/SET_ROOM_CBT_USER_ANSWER', e.data);
      },

      /**
       * CBT Doc 초기화
       */
      room_cbt_doc_set: (e) => {
        store.commit('cbt/SET_ROOM_CBT_DOC', e.data);
      }
    });
  }
}